export var TokenType;
(function (TokenType) {
    TokenType[TokenType["WHITESPACE"] = 0] = "WHITESPACE";
    TokenType[TokenType["NEWLINE"] = 1] = "NEWLINE";
    TokenType[TokenType["IF"] = 2] = "IF";
    TokenType[TokenType["APPLY"] = 3] = "APPLY";
    TokenType[TokenType["RULE"] = 4] = "RULE";
    TokenType[TokenType["META"] = 5] = "META";
    TokenType[TokenType["COLON"] = 6] = "COLON";
    TokenType[TokenType["COMMA"] = 7] = "COMMA";
    TokenType[TokenType["TRUE"] = 8] = "TRUE";
    TokenType[TokenType["FALSE"] = 9] = "FALSE";
    TokenType[TokenType["IDENTIFIER"] = 10] = "IDENTIFIER";
    TokenType[TokenType["LITERAL_INT"] = 11] = "LITERAL_INT";
    TokenType[TokenType["LITERAL_STRING"] = 12] = "LITERAL_STRING";
    TokenType[TokenType["ASSIGN"] = 13] = "ASSIGN";
    TokenType[TokenType["OP_EQ"] = 14] = "OP_EQ";
    TokenType[TokenType["OP_GT"] = 15] = "OP_GT";
    TokenType[TokenType["OP_LT"] = 16] = "OP_LT";
    TokenType[TokenType["OP_GTEQ"] = 17] = "OP_GTEQ";
    TokenType[TokenType["OP_LTEQ"] = 18] = "OP_LTEQ";
    TokenType[TokenType["OP_AND"] = 19] = "OP_AND";
    TokenType[TokenType["OP_OR"] = 20] = "OP_OR";
    TokenType[TokenType["OP_NOT"] = 21] = "OP_NOT";
    TokenType[TokenType["EXPR_START"] = 22] = "EXPR_START";
    TokenType[TokenType["EXPR_END"] = 23] = "EXPR_END";
    TokenType[TokenType["BLOCK_START"] = 24] = "BLOCK_START";
    TokenType[TokenType["BLOCK_END"] = 25] = "BLOCK_END";
    TokenType[TokenType["LIST_START"] = 26] = "LIST_START";
    TokenType[TokenType["LIST_END"] = 27] = "LIST_END";
    TokenType[TokenType["STMT_END"] = 28] = "STMT_END";
    TokenType[TokenType["PREPROC_DEFINE"] = 29] = "PREPROC_DEFINE";
    TokenType[TokenType["COMMENT"] = 30] = "COMMENT";
})(TokenType || (TokenType = {}));
